import { useMutation } from '@tanstack/react-query';
import { editAllRenewalType, editRenewalType } from './bulkChangeRenewalType';
import { invalidateRenewalLines } from './useRenewals';
import { globalError } from '../../../shared/notification/actions';
import { AxiosError } from 'axios';
import { invalidateManageRenewalsTotals } from './useManageRenewalsTotals';

export const useEditAllRenewalType = () => {
    return useMutation(editAllRenewalType, {
        onSuccess: () => {
            invalidateRenewalLines().then();
            invalidateManageRenewalsTotals().then();
        },
        onError: (error: AxiosError) => {
            globalError(error);
        }
    });
};

export const useEditRenewalType = () => {
    return useMutation(editRenewalType, {
        onSuccess: () => {
            invalidateRenewalLines().then();
            invalidateManageRenewalsTotals().then();
        },
        onError: (error: AxiosError) => {
            globalError(error);
        }
    });
};
